import { Routes } from '@angular/router'
import { publicRoutes } from './features/public/public.routes'
import { adminRoutes } from './features/admin/admin.routes'
import { superAdminRoutes } from './features/super-admin/super-admin.routes'
import { salonAdminRoutes } from './features/salon-admin/salon-admin.routes'
import { adsRoutes } from './features/ads/ads.routes'
import { chatRoutes } from './features/chat/chat.routes'

export const routes: Routes = [
	...publicRoutes,
	...adminRoutes,
	...superAdminRoutes,
	...salonAdminRoutes,
	...adsRoutes,
	...chatRoutes,
	{ path: '**', loadComponent: () => import('./shared/components/not-found/not-found') },
]
